import React, { useState } from 'react';
import GenericTable from '../../../generic-table/generic-table';
import { TopStockColumns } from './data';

const TopStockProducts = ({brands, data}) => {
	const [brand, setBrand] = useState({ value: 'all', label: 'All Brands' })
	const [page, setPage] = useState(0)
	const [rowsPerPage, setRowsPerPage] = useState(10)

	const handleChangePage = (_, newPage) => {
		setPage(newPage)
	}

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(event)
		setPage(0)
	}

	return (
		<div className='bg-white p-4 w-full flex flex-col'>
			<div className='flex justify-between items-center w-full'>
				<span className="text-xl font-medium">
					Top Stock Products
				</span>
				{/* <div>
					<BrandFilter brands={brands} onBrandChange={(b) => { setBrand(b) }} />
				</div> */}
			</div>
			<GenericTable
				columns={TopStockColumns}
				data={data}
				className='!px-0 !pt-5'
			/>
			{/* <GenericPagination
				rowsPerPage={rowsPerPage}
				page={page}
				setPage={setPage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				count={data.length}
				onPageChange={handleChangePage}
			/> */}
		</div>

	)
}

export default TopStockProducts
